import { Box } from "@mui/material";

interface BoxComponentProps {
  children: React.ReactNode;
  className?: string;
  mb?: number;
  [key: string]: any;
}

export function BoxComponent({ children, className, mb, ...props }: BoxComponentProps) {
  return (
    <Box className={className} mb={mb} {...props}>
      {children}
    </Box>
  );
}
